import * as React from "react";
import { Table } from "react-bootstrap";
import { NumericFormat } from "react-number-format";

export function ShowTableDaftarUser({ users, selectedId, onSelect }) {
  return (
    <section className="table-panel">
      <Table hover responsive className="data-table">
        <thead>
          <tr>
            <th>Username</th>
            <th>Tipe User</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr
              key={user.id}
              className={`row-clickable ${String(user.id) === String(selectedId) ? "active-row" : ""}`}
              onClick={() => onSelect(user.id)}
            >
              <td>{user.username}</td>
              <td>{user.tipeUser}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}

export function ShowTableKategori({ kategoris, selectedId, onSelect }) {
  return (
    <section className="table-panel">
      <Table hover responsive className="data-table">
        <thead>
          <tr>
            <th>Kode</th>
            <th>Nama</th>
          </tr>
        </thead>
        <tbody>
          {kategoris.map((kategori) => (
            <tr
              key={kategori.id}
              className={`row-clickable ${
                String(kategori.id) === String(selectedId) ? "active-row" : ""
              }`}
              onClick={() => onSelect(kategori.id)}
            >
              <td>{kategori.kode}</td>
              <td>{kategori.nama}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}

export function ShowTableMerk({ merks, selectedId, onSelect }) {
  return (
    <section className="table-panel">
      <Table hover responsive className="data-table">
        <thead>
          <tr>
            <th>Kode</th>
            <th>Nama</th>
          </tr>
        </thead>
        <tbody>
          {merks.map((merk) => (
            <tr
              key={merk.id}
              className={`row-clickable ${
                String(merk.id) === String(selectedId) ? "active-row" : ""
              }`}
              onClick={() => onSelect(merk.id)}
            >
              <td>{merk.kode}</td>
              <td>{merk.nama}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}

export function ShowTableBarang({ barangs, selectedId, onSelect }) {
  return (
    <section className="table-panel">
      <Table hover responsive className="data-table">
        <thead>
          <tr>
            <th>Kode</th>
            <th>Nama</th>
            <th>Harga Jual</th>
            <th>Harga Promo</th>
            <th>Stok</th>
            <th>Kategori</th>
            <th>Merk</th>

            <th>Flash sale</th>
          </tr>
        </thead>
        <tbody>
          {barangs.map((barang) => (
            <tr
              key={barang.id}
              className={`row-clickable ${
                String(barang.id) === String(selectedId) ? "active-row" : ""
              }`}
              onClick={() => onSelect(barang.id)}
            >
              <td>{barang.kode}</td>
              <td>{barang.nama}</td>
              <td>
                <NumericFormat
                  value={barang.hargaJual || "0"}
                  valueIsNumericString
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  allowNegative={false}
                />
              </td>
              <td>
                <NumericFormat
                  value={barang.hargaPromo || "0"}
                  valueIsNumericString
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  allowNegative={false}
                />
              </td>
              <td>{barang.stok || 0}</td>
              <td>{barang.kategori?.nama || "-"}</td>
              <td>{barang.merk?.nama || "-"}</td>
              <td>{barang.isFlashsale ? "Ya" : "Tidak"}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </section>
  );
}
